import React from 'react';
import './index.css';
import '@clockout-dev/design-elements/style.css';
import ReactDOM from 'react-dom/client';
import ClockoutRouter from './router/router';
import { ConfigProvider } from 'antd';

const root = ReactDOM.createRoot(document.getElementById('root'));

const originalConsoleError = console.error;

console.error = (...args) => {
    if (
        typeof args[0] === 'string' &&
        args[0].includes('When calling super()') &&
        args[0].includes('make sure to pass up the same props')
    ) {
        return;
    }
    originalConsoleError(...args);
};

root.render(
    <ConfigProvider
        theme={{
            components: {
                Menu: {
                    darkItemSelectedBg: '#4285F4',
                    darkSubMenuItemBg: 'transparent',
                    iconSize: '20px',
                    groupTitleFontSize: '20px',
                },
                // Plain antd fields share the design-elements field radius (`radius/input`, 16px).
                Input: { borderRadius: 16, borderRadiusSM: 16, borderRadiusLG: 16 },
                InputNumber: { borderRadius: 16, borderRadiusSM: 16, borderRadiusLG: 16 },
                Select: { borderRadius: 16, borderRadiusSM: 16, borderRadiusLG: 16 },
                DatePicker: { borderRadius: 16, borderRadiusSM: 16, borderRadiusLG: 16 },
            },
        }}
    >
        <ClockoutRouter />
    </ConfigProvider>
);
